import { Component, OnInit, Input } from '@angular/core';

import { Device } from '../../devices/device.model';
import { DeviceService } from '../../devices/device.service';

import { Organization } from '../../organization/organization.model';
import { OrganizationService } from '../../organization/organization.service';

import { Location } from '../../locations/location.model';
import { LocationService } from '../../locations/location.service';

import { LocationOrgFilterPipe } from '../../shared/location-org-filter.pipe';

import { NotificationService } from '../notification/notification.service';

@Component({
  selector: 'app-bulk-device-edit',
  templateUrl: './bulk-device-edit.component.html',
  styleUrls: ['./bulk-device-edit.component.scss']
})
export class BulkDeviceEditComponent implements OnInit {

  public devices: Device[] = [];
  public bulkOrgID: number;
  public bulkLocationID: number;
  public locationList: Location[];

  @Input('deviceIds') deviceIds: number[];

  constructor(
    private deviceService: DeviceService,
    public notificationService: NotificationService,
    public organizationService: OrganizationService,
    public locationService: LocationService,
  ) { }

  ngOnInit(): void {
    console.log(this.deviceIds);
    if (this.deviceIds) {
      this.deviceIds.forEach((id) => {
        this.devices.push(this.deviceService.device(id))
      })
      this.locationList = [...this.locationService.locations];
    }
  }

  saveDevice(device) {
    device.mssfix = true;
    this.deviceService.saveDevice(device);
  }

  bulkChange(property, $event) {
    let newVal = $event;

    if (property === 'org_id') {
      this.bulkLocationID = 0;
    }

    this.devices.forEach((device) => {
      device[property] = newVal;

      if (property === 'org_id') {
        device.location_id = 0;
      }
    })
  }

}
